import { message } from 'antd';
import { FC, ReactNode, useEffect, useState } from 'react';
import { LayoutSite } from '../components/layout';
import { getRaceDatas } from '../services/api.service';
import { findcolor, JsonLine } from '../types';
import './home.scss';

import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, ChartData, ChartDataset, } from 'chart.js';
import { Line } from 'react-chartjs-2';
import zoom from 'chartjs-plugin-zoom'
import { useNavigate } from 'react-router-dom';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, zoom);
  
/* -------------------------------------------------------------------------------- *\
|                               GraphsPage
\* -------------------------------------------------------------------------------- */
export const GraphsPage: FC<{ children?: ReactNode, race: string }> = ({ children, race }) =>
{
    const [currentrace, setCurrentRace] = useState<string>('');
    const [currentdatas, setDatas] = useState<JsonLine[]>([]);
    const [currentgraphdatas, setGraphDatas] = useState<ChartData<'line', number[], string>>({ labels: [], datasets: [] });

    const navigate = useNavigate();
    
    const options =
    {
        responsive: true,
        plugins:
        {
            legend:
            {
                position: 'bottom' as const,
            },
            zoom: {
                enabled: true,
                
                pan: {
                  enabled: true,
                  mode: "x" as const,
                },
                zoom: {
                    scaleMode: "x" as const,
                    mode: "x" as const,

                    wheel: {
                        enabled: true,
                    },
                    drag: {
                        enabled: true,
                        modifierKey: "shift" as const,
                    },
                }
            }
        },
    };
    /* -------------------------------------------------------------------------------- *\
    |                               builddatas
    \* -------------------------------------------------------------------------------- */
    const builddatas = (datas: JsonLine[]) =>
    {
        // var data =
        // {
        //     labels: [],
        //     datasets: []
        // }
        if (datas.length <= 0) return;
        if (datas[0].captures.length <= 0) return;

        //const distance = datas[0].captures[0].DistRemain;

        var graphdatas: ChartData<'line', number[], string> =
        {
            labels: [],
            datasets: []
        };
        var labels: string[] = [];
        for (var i = 0; i < datas.length; i++)
        {
            if (i % 10 === 0) labels.push(String(i));
        }
        labels = labels.reverse();
        graphdatas.labels = labels;

        for(const c of datas[0].captures)
        {
            var ds: ChartDataset<'line', number[]> = 
            {
                label: String(c.Number),
                data: [],
                borderColor: '#' + findcolor(c.Number).color,
                backgroundColor: '#' + findcolor(c.Number).color,
                pointRadius: 0,
                borderWidth: 1
            };

            for (i = 0; i < datas.length; i++)
            {
                if (i % 10 === 0) 
                {
                    const capt = datas[i].captures.find(n => n.Number === c.Number);
                    ds.data.push(capt === undefined ? 0 : capt.Odds);
                }
            }
            graphdatas.datasets.push(ds);
        }
        setGraphDatas(graphdatas);
     }
    /* -------------------------------------------------------------------------------- *\
    |                               getDatas
    \* -------------------------------------------------------------------------------- */
    const getDatas = async (race: string) =>
    {
        getRaceDatas(race)
            .then((datas: JsonLine[]) =>
            {
                setDatas(datas);
            })
            .catch(error =>
            {
                message.error(error.message);
                if (error.status === 403 || error.status === 401) navigate('/login');
            });
    }
    /* -------------------------------------------------------------------------------- *\
    |                               effects
    \* -------------------------------------------------------------------------------- */
    useEffect(() =>
    {
        if (currentrace) getDatas(currentrace);
    // eslint-disable-next-line
    }, [currentrace]);
    useEffect(() =>
    {
        setCurrentRace(race);
    }, [race]);
    useEffect(() =>
    {
        builddatas(currentdatas);
    }, [currentdatas]);
    
    return (
        <LayoutSite>
            <div className="home">
                <div className="home__header">
                    <div></div>
                    <div className='calendar__header__clock'></div>
                </div>
                <div className="home__body">
                    <div className="home__body__title">{currentrace}</div>
                    <Line options={options} data={currentgraphdatas} />
                </div>
            </div>
        </LayoutSite>
    );
}
